import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=2bcc1c60&scoped=true&"
import script from "./AccountCard.vue?vue&type=script&lang=js&"
export * from "./AccountCard.vue?vue&type=script&lang=js&"
import style0 from "./AccountCard.vue?vue&type=style&index=0&id=2bcc1c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcc1c60",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CDivider: require('@chakra-ui/vue').CDivider, CCheckbox: require('@chakra-ui/vue').CCheckbox})
